<template>
  <div class="createAn4-box">
    <div class="laber-box intro-x">
      <div
        v-for="(item, index) in ceateData4"
        :key="index"
        class="laberItem-box"
        :class="{
          isLaberTrue: payment == index,
        }"
        @click="getPayment(index)"
      >
        <div class="laberContent">
          <div class="itemLeftImg">
            <img :src="item.icon" alt="" />
          </div>

          <div class="itemRightText">
            <div class="item1">{{ item.title }}</div>
            <el-popover
              class="item"
              placement="top-start"
              width="600"
              trigger="hover"
              :content="item.content"
            >
              <div class="item2" slot="reference">{{ item.content }}</div>
            </el-popover>
          </div>
        </div>

        <div
          v-show="payment === index"
          class="float-yuan"
          :class="{ 'el-icon-check': payment === index }"
        ></div>
      </div>
    </div>

    <div class="table-box intro-x">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="功能模块" show-overflow-tooltip>
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <div class="scopeTitle">{{ scope.row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          label="选购终端"
          width="250"
          show-overflow-tooltip
        >
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span>{{ scope.row.formName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          label="有效期"
          width="100"
          show-overflow-tooltip
        >
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span class="scopeDiscounts">一年</span>
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          prop="money"
          label="金额"
          width="80"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>

    <div class="table-box-2 intro-x">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="订单详情" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="scopeTitle">{{ scope.row.title }}</div>
            <div class="scopeformName">{{ scope.row.formName }}</div>
          </template>
        </el-table-column>

        <el-table-column align="right" min-width="55" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="money-color"> ￥{{ scope.row.money }}</div>
            <div>有效期：一年</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="promotionCode-box intro-x">
      <div class="promotionCode">
        <span class="Code-title">优惠码</span>
        <div class="el-Input">
          <el-input
            v-model="discountsCode"
            placeholder="输入优惠码可在当前价格上再打折扣"
            @input="getCode"
          ></el-input>
        </div>
      </div>

      <div v-if="discountsCode.length >= 1" class="promotionMoney">
        {{ coupon_discount >= 1 ? "- ¥" + coupon_discount : " 无效优惠码" }}
      </div>
    </div>

    <div class="totalMoney-box intro-x">
      <div class="totalMoney-right">
        <div class="div1">总计金额</div>
        <!-- 使用 Vue filters过滤器  -->
        <div class="div2">¥ {{ (predictNum * discount) | formatMoney }}</div>
        <div class="div3">共省 ¥{{ price_discount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash";

import request from "../utils/request";

export default {
  filters: {},
  props: ["pladList", "mergeArr", "calcParam"],
  data() {
    return {
      payment: null,
      calcData: null,
      CodeMoney: null,
      discountsCode: "",
      discount: 1,
      pay_mode: 1,
      predictNum: null,
      price_discount: 0,
      pay_way: 1,
      createAn4Param: null,
      ceateData4: [
        {
          icon: require("../assets/images/huabei.png"),
          title: "授信模式",
          content:
            "每个应用可免费获得一次授信开通机会，授信成功后立即赠送授信额度，剩余费用采用授信额度方式支付。",
        },
        {
          icon: require("../assets/images/zhifubao.png"),
          title: "支付宝支付",
          content:
            "支持使用支付宝扫码支付，使用优惠码可享受折扣，一次付费，全年无忧，价格更低。",
        },
        {
          icon: require("../assets/images/qianbao.png"),
          title: "余额支付",
          content:
            "支持使用账户内余额支付，使用优惠码可享受折扣，价格更低，请提前充值保证余额充值",
        },
      ],
    };
  },
  computed: {
    tableData: function () {
      return this.mergeArr;
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init: function () {
      // let param = this.calcParam;
      request({
        url: "/api/plan/calc",
        method: "POST",
        data: {
          app_id: 1,
          plan: this.calcParam.plan,
          coupon: this.discountsCode,
          pay_mode: this.pay_mode,
          pay_way: this.pay_way,
        },
      })
        .then((res) => {
          this.predictNum = res.data.price;
          this.coupon_discount = res.data.coupon_discount;
          this.price_discount = res.data.price_discount;
          this.calcData = res.data;
          this.createAn4Param = {
            app_id: 1,
            plan: this.calcParam.plan,
            coupon: this.discountsCode,
            pay_mode: this.pay_mode,
            pay_way: this.pay_way,
          };
        })
        .catch((err) => {
          this.$message.error("接口错误");
        });
    },

    getPayment: function (index) {
      this.pay_mode = index >= 1 ? 1 : 0;
      this.pay_way = index == 2 ? "0" : 1;
      console.log(this.pay_mode);
      this.payment = index;
      this.init();
    },
    getCode: lodash.debounce(function () {
      this.init();
    }, 500),
  },
};
</script>
<style lang="scss" scoped>
.createAn4-box {
  margin-top: 30px;
  padding: 0 10vw;
  overflow: hidden;
  box-sizing: border-box;
  .laber-box {
    width: 100%;
    overflow: hidden;
    display: flex;
    .laberItem-box {
      float: left;
      width: 32%;
      min-width: 86px;
      height: 120px;
      background: #fff;
      padding: 0.5vw;
      box-sizing: border-box;
      overflow: hidden;
      border: 1px solid #eef2f7;
      cursor: pointer;
      border-radius: 22px;
      margin: 0 2% 2% 0;
      position: relative;
    }
    .laberItem-box:last-child {
      margin: 0;
    }
  }
  .itemLeftImg {
    float: left;
    overflow: hidden;
    width: 48px;
    line-height: 6.7;
    img {
      width: 48px;
      height: 48px;
      vertical-align: middle;
      display: inline-block;
    }
  }
  .itemRightText {
    float: left;
    width: calc(100% - 48px);
    box-sizing: border-box;
    padding-left: 5%;
    padding-top: 15px;
  }
  .laberContent {
    display: inline-block;
    width: 100%;
    .item1 {
      color: #333333;
      font-size: 14px;
      text-align: left;
    }
    .item2 {
      font-size: 12px;
      color: #999999;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
  .float-yuan {
    width: 20px;
    height: 20px;
    background: #1890ff;
    border-radius: 50%;
    position: absolute;
    right: 20px;
    bottom: 10px;
    text-align: center;
    line-height: 20px;
    color: #ffffff;
    font-weight: bold;
    box-shadow: #e2e2e2 0px 0px 2px;
  }
  .isLaberTrue {
    border-color: #1890ff !important;
  }
}

.scopeTitle {
  color: #333;
  font-size: 14px;
}

.scopeCotnent {
  color: #999999 !important;
  font-size: 12px !important;
}

.promotionCode-box {
  overflow: hidden;
  margin-top: 13px;

  .promotionCode {
    float: left;
    width: 100%;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      margin-right: 10px;
      color: #333333;
      font-size: 14px;
    }
    .el-Input {
      display: inline-block;
      height: 40px;
      width: 465px;
    }
  }
  .promotionMoney {
    float: right;
    height: 40px;
    line-height: 40px;
    color: #ff4242;
    font-size: 14px;
  }
}

.totalMoney-box {
  overflow: hidden;
  .totalMoney-right {
    float: right;
    text-align: right;
    .div1 {
      font-size: 16px;
      color: #728196;
    }
    .div2 {
      color: #1890ff;
      font-weight: bold;
      font-size: 20px;
      margin: 4px 0;
    }
    .div3 {
      font-size: 14px;
      color: #394251;
    }
  }
}

.table-box-2 {
  display: none;
}

@media screen and (max-width:600px) {
  .table-box-2 {
    display: block;
  }
  .scopeformName {
    color: #999999;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .scopeTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .Code-title {
    color: #333333 !important;
    font-size: 15px !important;
    padding-left: 6px !important;
    border-left: #1890ff 4px solid !important;
    height: 20px !important;
    line-height: 20px !important;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .table-box {
    display: none !important;
  }

  .createAn4-box {
    padding: 0 4vw !important;
    .laber-box {
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .totalMoney-box {
    margin-top: 1rem !important;
  }

  .laberItem-box {
    width: 100% !important;
    margin-right: 0 !important;
    padding-left: 20px !important;
  }
  .el-Input {
    width: 100% !important;
  }
    .money-color {
    color: #1890FF;
    font-size: 13px;
  }
}
</style>
